const versionInfo = {
    major: 1,
    minor: 2,
    patch: 4,
    build: 120
}
export const version = `${versionInfo.major}.${versionInfo.minor}.${versionInfo.patch}(${versionInfo.build})`;